import React from 'react';
import { CLASSNAME } from '@skin-seoul/service';
import shieldIcon from './assets/shield.png';
import packageIcon from './assets/package.png';
import { resolveImageSrc } from '../../../utils';

const TRUST_BADGES = [
  { label: '100% authentic', icon: shieldIcon },
  { label: 'Easy returns', icon: packageIcon },
];

export function CartTrustBadges() {
  return (
    <div className="relative z-[1] mx-3 flex min-h-7 flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-t-xl bg-primary-50 px-0.5 py-1.5">
      {TRUST_BADGES.map(({ label, icon }) => (
        <div key={label} className="flex shrink-0 items-center gap-px">
          <img src={resolveImageSrc(icon)} alt="" className="size-3.5 shrink-0" />
          <span className={`text-label-small font-regular text-neutral-600 ${CLASSNAME.NOT_TRANSLATE}`}>{label}</span>
        </div>
      ))}
    </div>
  );
}
